/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedAffirm_viewer$ref = any;
export type PdpSharedAffirm_viewer = {
    readonly affirmEnabled: boolean | null;
    readonly regionalInfo: ReadonlyArray<{
        readonly countryCode: string | null;
    } | null> | null;
    readonly " $refType": PdpSharedAffirm_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedAffirm_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "affirmEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "AFFIRM"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"AFFIRM\")"
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "countryCode",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'cc85f0e424435e768f5ccfa21cc6727c';
export default node;
